'use strict';

import users from '@/assets/js/api/functions';

export default {
    namespaced: true,
    state: {
        usersList: [],
        userRole: [],
        userDetails: {}
    },
    getters: {
        getUsersList: (state) => state.usersList,
        getUserRole: (state) => state.userRole,
        getUserDetails: (state) => state.userDetails
    },
    mutations: {
        SET_USER_ROLE(state, payload) {
            state.userRole = payload;
        },
        SET_USERS_LIST(state, payload) {
            state.usersList = payload;
        },
        SET_USER_DETAILS(state, payload) {
            state.userDetails = payload;
        },
        CLEAR_STATE(state) {
            state.usersList = [];
            state.userDetails = {};
        }
    },
    actions: {
        fetchUsers(context, payload) {
            let { config } = payload || {};
            return new Promise((resolve, reject) => {
                users
                    .getData({ to: '/cms-users', config })
                    .then((response) => {
                        // console.log(response);

                        Object.values(response.data).map((key, index) => {
                            response.data[index].full_name = [key.first_name, key.last_name].filter(Boolean).join(' ');
                            response.data[index].is_active = key.status == 'ACTIVE' ? true : false;
                        });
                        context.commit('SET_USERS_LIST', response);
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        context.commit('SET_USERS_LIST', []);
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        findUser(context, payload) {
            let { id, config } = payload || {};
            return new Promise((resolve, reject) => {
                users
                    .getData({ to: `/cms-users/${id}`, config })
                    .then((response) => {
                        // console.log(response);

                        response.data.full_name = [response.data.first_name, response.data.last_name].filter(Boolean).join(' ');
                        response.data.is_active = response.data.status == 'ACTIVE' ? true : false;
                        context.commit('SET_USER_DETAILS', response.data);
                        context.commit('SET_USER_ROLE', response.data.role);
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        context.commit('SET_USER_DETAILS', {});
                        context.commit('SET_USER_ROLE', {});
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        findUserRole(context, payload) {
            let { config } = payload || {};
            return new Promise((resolve, reject) => {
                const id = context.rootState.authentication.userInfo.id;
                users
                    .getData({ to: `/cms-users/${id}/roles`, config })
                    .then((response) => {
                        // console.log(response);
                        context.commit('SET_USER_ROLE', response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        context.commit('SET_USER_ROLE', {});
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        addUser(context, payload) {
            let { data, config } = payload || {};
            return new Promise((resolve, reject) => {
                users
                    .postData({ to: '/cms-users/invite', data, config })
                    .then((response) => {
                        // console.log(response);
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        createUser(context, payload) {
            let { data, config } = payload || {};
            return new Promise((resolve, reject) => {
                users
                    .postData({ to: '/cms-users', data, config })
                    .then((response) => {
                        // console.log(response);
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        updateUser(context, payload) {
            let { id, config } = payload || {};
            return new Promise((resolve, reject) => {
                users
                    .putData({ to: `/cms-users/${id}`, config })
                    .then((response) => {
                        // console.log(response);
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        deleteUser(context, payload) {
            let { id, config } = payload || {};
            return new Promise((resolve, reject) => {
                users
                    .deleteData({ to: `/cms-users/${id}`, config })
                    .then((response) => {
                        // console.log(response);
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        }
    }
};
